import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Form, Formik } from 'formik';

const SaaSUserForm = (props: any) => {
  const { entity, onSubmit, errors, handleCancel, platformRoles } = props;
  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down('sm')
  );
  const roleOptions = Array.isArray(platformRoles) ? platformRoles : [];

  return (
    <Formik
      initialValues={{
        ...entity,
        platformRoleIds: Array.isArray(entity?.platformRoleIds)
          ? entity.platformRoleIds
          : [],
      }}
      enableReinitialize
      validate={(values) => {
        const next: any = {};
        if (!values.fullName) next.fullName = 'Kötelező mező';
        return next;
      }}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(
          {
            id: values.id,
            fullName: values.fullName,
            platformRoleIds: values.platformRoleIds ?? [],
          },
          setSubmitting
        );
      }}
    >
      {({
        isSubmitting,
        values,
        touched,
        handleChange,
        setFieldValue,
        errors: validationErrors,
      }) => (
        <Form>
          <Paper>
            <Grid container spacing={2} sx={{ justifyContent: 'left', p: 5 }}>
              <Grid size={12}>
                <h2>SaaS felhasználó szerkesztése</h2>
                <Typography variant="body2" color="text.secondary">
                  Platform szerepkör hozzárendelés. A bérlői szerepkörök a
                  Felhasználók oldalon vannak.
                </Typography>
              </Grid>
              <Grid size={12}>
                <Box sx={{ color: 'red' }}>
                  {(errors ?? []).map((error: string) => (
                    <li key={error}>{error}</li>
                  ))}
                </Box>
              </Grid>
              <Grid size={12}>
                <TextField
                  value={values.fullName ?? ''}
                  onChange={handleChange}
                  label="Megjelenítési név"
                  name="fullName"
                  fullWidth
                  autoFocus
                  error={!!touched.fullName && !!validationErrors.fullName}
                  helperText={
                    !!touched.fullName &&
                    !!validationErrors.fullName &&
                    (validationErrors.fullName as string)
                  }
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  value={values.email ?? ''}
                  label="Email"
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                <Autocomplete
                  multiple
                  options={roleOptions}
                  value={roleOptions.filter((r: any) =>
                    (values.platformRoleIds ?? []).includes(r.id)
                  )}
                  getOptionLabel={(o: any) => o.name ?? String(o.id)}
                  isOptionEqualToValue={(a: any, b: any) => a.id === b.id}
                  onChange={(_e, selected: any[]) =>
                    setFieldValue(
                      'platformRoleIds',
                      selected.map((x) => x.id)
                    )
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Platform szerepkörök"
                      helperText="A platform szerepkörök adják a SaaS jogosultságokat."
                    />
                  )}
                />
              </Grid>
              <Grid container sx={{ pt: 3, justifyContent: 'left' }}>
                <Grid
                  size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }}
                  sx={{ p: 1 }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth={isSmallScreen}
                    disabled={isSubmitting}
                  >
                    Mentés
                  </Button>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: isSmallScreen ? 12 : 'auto' }}
                  sx={{ p: 1 }}
                >
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth={isSmallScreen}
                    onClick={handleCancel}
                  >
                    Mégse
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      )}
    </Formik>
  );
};

export default SaaSUserForm;
